import { createSlice } from "@reduxjs/toolkit";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";
import { dictService } from "../../services/dictService";

export const getGroups = createCustomAsyncThunk(
    "dicts/groups/get",
    async params => await dictService.getGroups(params)
)

const studiosSlice = createSlice({
    name: "dicts/groups",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null
    }),
    extraReducers: builder => {
        builder
            .addCase(getGroups.pending, state => { state.isLoading = true })
            .addCase(getGroups.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getGroups.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error
            })
    }
})

export const groupSelectors = defaultEntityAdapter.getSelectors(x => x.dicts.groups)

export default studiosSlice.reducer